import * as React from 'react';

import PageWrapper from '~/common/layout/PageWrapper';
import PageContent from '~/common/layout/PageContent';
import PageContentWrapper from '~/common/layout/PageContentWrapper';

import SideMenu from '../containers/common/SideMenu';
import SalesHeader from '../containers/sales/SalesHeader';
import SalesFilter from '../containers/sales/SalesFilter';
import SalesList from '../containers/sales/SalesList';
import SalesTotals from "~/apps/pos/admin/containers/sales/SalesTotals";


export default function (children = null) {
  return (
    <React.Fragment>
      <PageWrapper>
        <SideMenu/>
        <PageContent>
          <SalesHeader/>
          <SalesFilter/>
          <SalesTotals/>
          <PageContentWrapper>
            <SalesList/>
          </PageContentWrapper>
          {children}
        </PageContent>
      </PageWrapper>
    </React.Fragment>
  );
};
